export const navigationDict = {
  info: {
    name: '宁波城市可信数据空间',
    address: '地址：鄞州区新材料国际创新中心B1栋8楼',
    contact: '联系人：张老师 18768179315',
    consultationHotline: '咨询热线：+86 87179858',
    workingHours: '工作日 9:00‑12:00，14:00‑17:30',
  },
  company: [
    { name: '行业流通平台', href: '#' },
    {
      name: '纺织服装',
      href: 'https://www.yunyee-data.com/buyer/index.html#/home',
    },
    { name: '港航物流', href: 'http://www.psdex.cn/cust/index' },
    { name: '金融服务', href: 'http://jrsjjy.com/' },
  ],
  legal: [
    { name: '合规中心', href: '#' },
    {
      name: '宁波市数据开放平台',
      href: 'http://data.ningbo.gov.cn/sjkfptold/#/home?t=1721197969107&id=1',
    },
    { name: '浙江省数据知识产权登记', href: 'https://www.zjip.org.cn/home' },
    {
      name: '宁波市公共数据授权运营平台',
      href: 'https://www.nbdataspace.com:40061/',
    },
    // { name: '浙江省公共数据资源登记平台', href: '#' },
  ],
};
